/**
 * Creates the payload for CreateRecordForProfileRequestAsync API
 * Matches the exact API format:
 * {
 *   "data": [
 *     { "name": "ctpt_name", "value": "...", "type": "string" },
 *     { "name": "ctpt_daterequested", "value": "...", "type": "string" },
 *     { "name": "ctpt_reasonforcontacting", "value": "...", "type": "string" },
 *     { "name": "ctpt_employee", "value": "...", "type": "lookup", "relatedentity": "contacts" },
 *     { "name": "ctpt_employer", "value": "...", "type": "string" },
 *     { "name": "ctpt_emailaddress", "value": "...", "type": "string" }
 *   ]
 * }
 */
export const CreateEmployeeProfileRequestPayload = async (JsonData) => {
  const details = JsonData.data;
  const name = details.find((d) => d.name === "name")?.value || "";
  const email = details.find((d) => d.name === "email")?.value || "";
  const employer = details.find((d) => d.name === "employer")?.value || "";
  const employeeId = JsonData.employeeId;
  const reasonForContacting = details.find((d) => d.name === "reasonForContacting")?.value || "";

  // Build the data array matching CreateRecordForProfileRequestAsync (email last)
  const data = [
    {
      name: "ctpt_name",
      value: name,
      type: "string",
    },
    {
      name: "ctpt_daterequested",
      value: new Date().toISOString(),
      type: "string",
    },
    {
      name: "ctpt_reasonforcontacting",
      value: reasonForContacting || "",
      type: "string",
    },
    {
      name: "ctpt_employee",
      value: employeeId,
      type: "lookup",
      relatedentity: "contacts",
    },
    {
      name: "ctpt_employer",
      value: employer || "",
      type: "string",
    },
    {
      name: "ctpt_emailaddress",
      value: email,
      type: "string",
    },
  ];

  // Return in the exact format expected by the API: { data: [...] }
  return {
    data: data,
  };
};

